import { Base } from "../core/base.model";
import { HorarioLaboral } from "./horario-laboral.model";

export class EmpleadoHorario extends Base {
  id: number;
  idEmpleado: number;
  idHorarioLaboral: number;
  fechaInicioVigencia: Date;
  fechaFinVigencia: Date;
  estatus: string;
  fechaCreacion: Date;
  horarioLaboral: HorarioLaboral;
}
